import { Middleware } from "redux";

import { setApplicantFormData } from "../../features/AC/Applicant/applicant.slice";
import { setIncidentFormData } from "../../features/AC/Incident/incident.slice";
import { setPerpetratorFormData } from "../../features/AC/Perpetrator/perpetrator.slice";
import { setPropertyIncidentFormData } from "../../features/OC/Property/Incident/incident.slice";
import { setOwnerFormData } from "../../features/OC/Property/Owner/owner.slice";
import { setVehicleIncidentFormData } from "../../features/OC/Vehicle/Incident/incident.slice";
import { setVehicleIntroductoryFormData } from "../../features/OC/Vehicle/Introductory/introductory.slice";
import { setVehicleOwnerFormData } from "../../features/OC/Vehicle/VehicleOwner/vehicleOwner.slice";
import {
  OC_MASK,
  PESEL_MASK,
  PHONE_MASK,
  ZIPCODE_MASK,
} from "../../utilities/masks/constants";
import { RootState } from "../rootReducer";
import { Payload } from "../types";

const masks = [PHONE_MASK, PESEL_MASK, OC_MASK, ZIPCODE_MASK];
const actions = [
  setApplicantFormData.type,
  setIncidentFormData.type,
  setPerpetratorFormData.type,
  setVehicleIntroductoryFormData.type,
  setVehicleIncidentFormData.type,
  setVehicleOwnerFormData.type,
  setPropertyIncidentFormData.type,
  setOwnerFormData.type,
];

function removeMasks(payload: Payload) {
  const newPayload: Payload = {};

  for (const [key, value] of Object.entries(payload)) {
    if (typeof value !== "object" && typeof value !== "undefined") {
      newPayload[key] = !masks.includes(value) ? value : "";
    }

    if (typeof value === "object") {
      newPayload[key] = { ...removeMasks(value as Payload) };
    }
  }

  return newPayload;
}

export const removeMasksFromValueMiddleware: Middleware<unknown, RootState> =
  () => (next) => (action) => {
    const { type, payload } = action;

    if (!actions.includes(type)) {
      return next(action);
    }

    const newPayload: Payload = removeMasks(payload);
    const actionWithRemovedMasksPayload = {
      ...action,
      payload: { ...newPayload },
    };

    return next(actionWithRemovedMasksPayload);
  };
